<template>
	<div class="insideBody">
		<div class="literature">
				<div class="content">
					<div class="top clr">
						<div class="fl tit">TO :</div>
						<div class="con clr">
							<img class="fl img" :src="$url+userinfo.masteravatar">
							<span class="fl name">{{userinfo.mastername}}</span>
						</div>
					</div>
					<div class="middle">
						<!-- <div class="time">2020-06-18 15:30</div> -->
						<div class="conlist" ref="conlistscroll" :style="{height: height+'px'}">
							<template v-if="countpage > 0">
								<ul v-infinite-scroll="load" infinite-scroll-disabled="disabled" >
									<li class="clr" :class="item.type == 2 ? 'my':''" v-for="(item,index) in tableData" :key="index">
										<img class="img" :src="$url+item.useravatar">
										<div class="con">
											<div class="tits"><span class="spanpad">{{item.time}}</span>{{item.username}}</div>
											<div class="text">{{item.msg}}</div>
										</div>
									</li>
								</ul>
							</template>
							<template v-else>
								<div class="noneImg">
									<img src="../../assets/images/none.png">
								</div>
							</template>
							<!-- <p class="noneImg" v-if="disabled && tableData.length > 0">没有更多了</p> -->
						</div>
						<div class="end" ref="heightend">
							<div class="input">
								<el-input :autosize="{ minRows: 3, maxRows: 10}" type="textarea" placeholder="请输入内容" v-model="textarea"></el-input>
							</div>
							<div class="btnText">
								<div class="btn" @click="sendmsg">回复</div>
							</div>
						</div>
					</div>
				</div>
		</div>
	</div>
</template>
<script>
import {getmsglist,sendmsg} from '@/api/control5'
export default {
  data(){
    return {
			height: null,
			textarea: null,
			limit: 10,
			page: 0,
			countpage: 1,
			disabled: false,
			tableData: [],
			dataObj: {},
       
      userinfo:this.utils.storageGet("userinfo")
		};
	},
	created(){
	},
	methods:{
		datalist(){
			var that = this;
			getmsglist({
				userid: that.userinfo.userid,
				limit: this.limit,
				page: that.page
			}).then(res => {
				that.dataObj = res;
				that.countpage = Math.ceil(res.count / that.limit);
				that.tableData = that.tableData.concat(res.data);
				if(that.page >= that.countpage){
					that.disabled = true;
				};
				that.$nextTick(() => {
					that.$refs.conlistscroll.scrollTop = that.$refs.conlistscroll.scrollHeight;
				});
			});
		},
		load(){
			var that = this;
			this.page += 1;
			that.datalist();
		},
		sendmsg(){
			var that = this;
			if(that.textarea == undefined || !that.textarea.trim()){
				that.$message.error('请输入内容');
				return false;
			};
			sendmsg({
				userid: that.userinfo.userid,
				teachid: that.userinfo.masterid,
				msg: that.textarea
			}).then(res => {
				var obj = { //模拟回复
					msg: that.textarea,
					time: that.defaultDate(),
					type: 2,
					useravatar: that.userinfo.avatar,
					userid: that.userinfo.userid,
					username: that.userinfo.username
				};
				that.tableData.push(obj);
				that.$message.success('回复成功');
				that.$nextTick(() => {
					that.$refs.conlistscroll.scrollTop = that.$refs.conlistscroll.scrollHeight;
				});
			});
		},
		defaultDate(){
			 var that = this,date = new Date(),year = date.getFullYear(),month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):(date.getMonth()+1),da = date.getDate() < 10 ? '0'+date.getDate():date.getDate(),houram = date.getHours() > 12 ? date.getHours() - 12:date.getHours(),hour = houram < 10 ? '0'+houram:houram,minute = date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes(), date = year+'-'+month+'-'+da+' '+hour+':'+minute;
			return date;
		},
	},
	mounted(){
		var that = this;
		that.height = window.innerHeight - that.$refs.heightend.offsetHeight - (340*that.utils.per());
	},
	components: {
		
	},
}
</script>
<style scoped>
	.spanpad{
		padding-right: 0.2rem;
	}
</style>